import { Box, Button, Typography } from "@material-ui/core";
import { FC, useCallback, useEffect } from "react";
import { useStyles } from "./styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import {
  fleetReportsSetFilter,
  fleetReportsSetStatusFilter,
  getFleetReportsData,
} from "actions/fleetReportsAction";
import { useDispatch } from "react-redux";
import { SearchInput } from "componentsNew/elements/SearchInput";
import { ModalWindow } from "componentsNew/modals/ModalWindow";
import { FleetReportsUpdateDialog } from "componentsNew/modals/modalContent/FleetReportsUpdateDialog";
import { CustomDrawer } from "componentsNew/drawers/CustomDrawer";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { Tune } from "@mui/icons-material";
import { DateFilter } from "componentsNew/elements/DateFilter";
import { SelectApiField } from "componentsNew/elements/SelectApiField";
import api from "api";
import { InvoiceStatusSelect } from "componentsNew/elements/SelectField";
import { MultipleSelectField } from "componentsNew/elements/MultipleSelectField";
import { fleetReportStatusFilter } from "constants/constants";
import { FleetReportsTableSettingsDrawerContent } from "componentsNew/drawers/drawerContent/FleetReportsTableSettingsDrawerContent";
import useResize from "hooks/useResize";

interface PropsType {}

const getVanGroups = () => api.getVanGroups();

export const FleetReportsHead: FC<PropsType> = () => {
  const classes = useStyles();
  const { width } = useResize();
  const dispatch = useDispatch();
  const { fleetReportFilters, selectedIdList } = useTypeSelectors((state) => state.fleetReports);

  useEffect(() => {
    const [year, month] = fleetReportFilters?.month?.split("-");
    dispatch(
      getFleetReportsData({
        month: Number(month),
        year: Number(year),
      }),
    );
  }, [fleetReportFilters?.month, dispatch]);

  const handleSearch = useCallback(
    (value: string) => {
      if ((fleetReportFilters.search || "") === value) return;
      dispatch(fleetReportsSetFilter({ search: value }));
    },
    [dispatch, fleetReportFilters.search],
  );

  return (
    <Box className={classes.paper}>
      <Box className={`${classes.leftBox} ${classes.gridBox}`}>
        <InvoiceStatusSelect
          fullWidth
          value={fleetReportFilters.invoice}
          onChange={(invoice: number | string) =>
            dispatch(fleetReportsSetFilter({ invoice: Number(invoice) }))
          }
        />
        <Box>
          <Typography className={classes.label}>Fleet Vendor</Typography>
          <SelectApiField
            value={fleetReportFilters.company as number | null}
            onChange={(company: number) => dispatch(fleetReportsSetFilter({ company }))}
            api={getVanGroups}
            renderValue={(val: any) => val.name}
            hasAllOption
            allLabel="All Vendors"
          />
        </Box>
        <MultipleSelectField
          label="Fleet Status"
          options={fleetReportStatusFilter}
          selected={fleetReportFilters.statuses}
          action={(statuses: number[]) => dispatch(fleetReportsSetStatusFilter(statuses))}
          allLabel="All Status"
          hideAllOption
        />
        <Box>
          <Typography className={classes.label}>Month</Typography>
          <DateFilter
            type={"month"}
            monthValue={fleetReportFilters.month}
            monthChange={(value: string) => dispatch(fleetReportsSetFilter({ month: value }))}
          />
        </Box>
      </Box>
      <Box className={classes.rightBox}>
        <Box className={classes.leftBox}>
          <SearchInput
            value={fleetReportFilters.search || ""}
            onChange={handleSearch}
            placeholder={"Fleet Number/Plate/Vin"}
          />
          <CustomDrawer
            customWidth={440}
            buttonType={"custom"}
            drawer_name={`filter-schedule-settings`}
            drawerTitle={`Table Settings`}
            customButtonElement={
              <Button className={classes.settingsBtn} variant={"outlined"}>
                <Tune /> {width > 840 ? <Typography>Settings</Typography> : ""}
              </Button>
            }
          >
            <FleetReportsTableSettingsDrawerContent />
          </CustomDrawer>
        </Box>
        <ModalWindow
          buttonType={"custom"}
          modal_name={"edit-fleet-reports-modal"}
          modalTitle={"Update Fleet Reports"}
          customButtonElement={
            <CustomButton
              buttonText={"Update Reports"}
              onClick={() => null}
              theme="blue"
              variant="contained"
            />
          }
          isDisabled={!selectedIdList.length}
        >
          <FleetReportsUpdateDialog />
        </ModalWindow>
      </Box>
    </Box>
  );
};
